var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorMailValidation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 138,
    viewBox: "0 0 131 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 56.6702V127C3 131.418 6.58172 135 11 135H120C124.418 135 128 131.418 128 127V56.6702M3 56.6702L65.6341 101.934C65.9871 102.189 66.4645 102.187 66.8146 101.928L128 56.6702M3 56.6702L21.1686 41.4395M128 56.6702L109.105 41.4395",
    stroke: "#121212",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8955 71.1758V11C21.8955 6.58173 25.4772 3 29.8955 3H101.105C105.523 3 109.105 6.58172 109.105 11V71.1758",
    stroke: "#121212",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.485 32.8085L53.238 42.5415C54.0199 43.3217 54.0199 44.5868 53.2381 45.3671L43.1624 55.4223C42.3806 56.2025 42.3806 57.4676 43.1624 58.2478L51.2374 66.3066C52.0193 67.0869 53.2869 67.0869 54.0687 66.3066L64.1442 56.2516C64.9261 55.4713 66.1937 55.4713 66.9755 56.2515L77.6536 66.9077C78.4354 67.6879 79.703 67.6879 80.4849 66.9077L88.8396 58.5699C89.6214 57.7897 89.6214 56.5246 88.8395 55.7444L78.1615 45.0882C77.3797 44.308 77.3796 43.0429 78.1615 42.2626L88.2371 32.207C89.0189 31.4268 89.0189 30.1617 88.2371 29.3815L80.162 21.3227C79.3801 20.5425 78.1125 20.5425 77.3306 21.3228L67.2551 31.3783C66.4733 32.1586 65.2057 32.1586 64.4238 31.3783L54.6709 21.6451C53.8891 20.8649 52.6215 20.8649 51.8396 21.6451L43.485 29.9829C42.7031 30.7632 42.7031 32.0283 43.485 32.8085Z",
    stroke: "#121212",
    strokeWidth: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5352 121.22L52.4189 94.3848",
    stroke: "#121212",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.662 123.197C113.754 124.042 115.324 123.842 116.17 122.75C117.015 121.658 116.815 120.088 115.723 119.243L112.662 123.197ZM115.723 119.243L80.1122 91.6824L77.0519 95.6365L112.662 123.197L115.723 119.243Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorMailValidation);
export default __webpack_public_path__ + "static/media/errorMailValidation.066595d65aedcc34383a3e62b45bbc42.svg";
export { ForwardRef as ReactComponent };